// extracted by mini-css-extract-plugin
module.exports = {"container":"SideMenu__container--391eG","menuBtn":"SideMenu__menuBtn--3T5Au"};